import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Modal,
  Spinner,
  Pagination,
} from "react-bootstrap";
import { BsPlus, BsX, BsSend } from "react-icons/bs";
import { FaTrash } from "react-icons/fa";
import AdminScreenHeader from "../admin/adminScreenHeader";
import "../../css/client/form24Q.css";
import { apiPost } from "../../service/admin/apiService";
import Loader from "../loader";
import { showError, showSuccess } from "../../utils/toast";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import {
  formGSTR1Fields,
  getPreviousMonthAndFY,
  isDataSentToCA,
  isDataReviewByCA,
} from "../../utils/client/misc";
import FormGSTR1Table from "./formGSTR1Table";
import ExportToExceljs from "../../utils/exportToExcel";
import DateFilters from "./dateFilters";

const FormGSTR1 = () => {
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [formfinancialYear, setFormFinancialYear] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedFYearId, setSelectedFYearId] = useState(0);
  const [selectedQuarter, setSelectedQuarter] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [formGSTR1Info, setFormGSTR1Info] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [copyDataloading, setCopyDataLoading] = useState(false);
  const [submitToCALoading, setsubmitToCALoading] = useState(false);
  const [isDataSendToCA, setIsDataSendToCA] = useState(false);
  const [isDataReviewedByCA, setIsDataReviewedByCA] = useState(false);
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [empIds, setEmpIds] = useState([]);
  const navigate = useNavigate();

  const closeModal = () => setShowModal(false);
  let clientInfo = JSON.parse(localStorage.getItem("clientInfo"));

  const filteredGSTR1Info = formGSTR1Info.filter((info) => {
    const fullName = `${info?.sug}`.toLowerCase();
    const term = searchTerm.toLowerCase();
    return info?.sug.toLowerCase().includes(term) || fullName.includes(term);
  });

  useEffect(() => {
    const calculatedMaxPage = Math.ceil(filteredGSTR1Info.length / limit) || 1;
    setMaxPage(calculatedMaxPage);
    if (activePage > calculatedMaxPage) setActivePage(1);
  }, [filteredGSTR1Info, limit]);

  const initialState = Object.fromEntries(
    formGSTR1Fields.map((f) => [f.key, ""])
  );
  const [formData, setFormData] = useState(initialState);

  useEffect(() => {
    if (formGSTR1Info.length > 0 && isDataSentToCA(formGSTR1Info) === true) {
      setIsDataSendToCA(true);
    } else {
      setIsDataSendToCA(false);
    }
    if (formGSTR1Info.length > 0 && isDataReviewByCA(formGSTR1Info) === true) {
      setIsDataReviewedByCA(true);
    } else {
      setIsDataReviewedByCA(false);
    }
  }, [formGSTR1Info]);

  useEffect(() => {
    setEmpIds([]);
  }, [selectedYear, selectedQuarter, selectedMonth]);

  const deleteInfo = async (empId) => {
    if (isDataSendToCA) return;

    if (empId === 0) {
      showError("You have not selected any info to delete");
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      width: "320px",
      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "btn btn-sm btn-danger",
        cancelButton: "btn btn-sm btn-secondary",
      },
    });

    // if (result.isConfirmed) {
    //   try {
    //     const payload = {
    //       action: "formdelete",
    //       ty: "formgstr1",
    //       to: clientInfo?.tk,
    //       id: empId,
    //     };
    //     const response = await apiPost(process.env.REACT_APP_API_URL, payload);
    //     if (Number(response?.errordetails?.errorcode) > 0) {
    //       showError(response?.errordetails?.error);
    //     } else if (response?.responsedetails) {
    //       showSuccess("Selected info delete successfully!!!");
    //       getGSTR1Info();
    //     }
    //   } catch (err) {
    //     console.error("Error:", err);
    //     showError("Something went wrong");
    //   }
    // }

    if (result.isConfirmed) {
      try {
        const results = await Promise.allSettled(
          empIds.map((empId) =>
            apiPost(process.env.REACT_APP_API_URL, {
              action: "formdelete",
              ty: "formgstr1",
              to: clientInfo?.tk,
              id: empId,
            })
          )
        );
        let processed = 0;
        results.forEach((result, index) => {
          processed++;
          if (result.status === "fulfilled") {
            if (processed === results.length) {
              showSuccess("Selected info delete successfully!!!");
              setEmpIds([]);
              getGSTR1Info();
            }
          } else {
            console.error(`Failed to delete ID ${index}`, result.reason);
            showError(`Failed to delete ID ${index}`, result.reason);
            // showError(result?.errordetails?.error);
            return;
          }
        });
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
      }
    }
  };

  const getGSTR1Info = async () => {
    if (clientInfo?.tk && clientInfo?.tk !== "") {
      if (selectedFYearId <= 0) {
        showError("Please select financial year to proceed");
        return;
      }

      if (selectedQuarter === "") {
        showError("Please select quarter to proceed");
        return;
      }

      if (selectedMonth === "") {
        showError("Please select month to proceed");
        return;
      }

      setShowLoader(true);
      const payload = {
        action: "formlist",
        to: clientInfo?.tk,
        ty: "formgstr1",
        fi: selectedFYearId,
        mn: selectedMonth,
        // clid: clientInfo.client?.id,
      };

      console.log("payload", payload);

      try {
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);

        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
          setShowLoader(false);
        } else if (response?.responsedetails) {
          console.log("response123", response?.responsedetails);
          setFormGSTR1Info(response?.responsedetails || []);
          setTimeout(() => {
            setShowLoader(false);
          }, 3000);
        }
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
        setShowLoader(false);
      } finally {
        setShowLoader(false);
      }
    }
  };

  const handleAdd = () => {
    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }
    setShowModal(true);
    setEditingIndex(null);
    setLoading(false);
    setFormData(initialState);
  };

  const handleEdit = (selectedInfo) => {
    if (isDataSendToCA) return;
    setFormData({
      sug: selectedInfo["sug"],
      tn: selectedInfo["tn"],
      inv: selectedInfo["inv"],
      indt: selectedInfo["indt"],
      ra: selectedInfo["ra"],
      tv: selectedInfo["tv"],
      ig: selectedInfo["ig"],
      cg: selectedInfo["cg"],
      sg: selectedInfo["sg"],
      iv: selectedInfo["iv"],
      ce: selectedInfo["ce"],
      id: selectedInfo["id"],
    });
    const index = formGSTR1Info.findIndex((el) => el.id === selectedInfo["id"]);
    setEditingIndex(index);
    setLoading(false);
    setShowModal(true);
  };

  const saveGSTR1Info = async (transType) => {
    if (loading) return;

    if (clientInfo?.tk && clientInfo?.tk !== "") {
      if (formData["sug"] === "") {
        showError("Please enter supplier name to proceed");
        return;
      }

      if (formData["tn"] === "") {
        showError("Please enter trade/legal name to proceed");
        return;
      }

      setLoading(true);

      const payload = {
        action: transType === "addInfo" ? "formadd" : "formupdate",
        to: clientInfo?.tk,
        ty: "formgstr1",
        fi: selectedFYearId,
        mn: selectedMonth,
        sug: formData["sug"],
        tn: formData["tn"],
        in: formData["inv"],
        indt: formData["indt"],
        ra: formData["ra"],
        tv: formData["tv"],
        ig: formData["ig"],
        cg: formData["cg"],
        sg: formData["sg"],
        iv: formData["iv"],
        ce: formData["ce"],
        ...(transType === "updateInfo" && { id: formData["id"] }),
      };

      console.log("payload", payload);

      try {
        const response = await apiPost(process.env.REACT_APP_API_URL, payload);

        if (Number(response?.errordetails?.errorcode) > 0) {
          showError(response?.errordetails?.error);
          setLoading(false);
        } else if (response?.responsedetails.success === "yes") {
          console.log("response", response?.responsedetails);
          setTimeout(() => {
            setLoading(false);
            if (transType === "updateInfo") {
              showSuccess("Selected info updated successfully!!!");
            } else {
              showSuccess("info created successfully!!!");
            }
            setShowModal(false);
            getGSTR1Info();
          }, 3000);
        }
      } catch (err) {
        console.error("Error:", err);
        showError("Something went wrong");
        setShowLoader(false);
      } finally {
        setShowLoader(false);
      }
    }
  };

  const getLastMonthData = async () => {
    if (copyDataloading) return;

    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }

    setCopyDataLoading(true);

    if (clientInfo?.tk && clientInfo?.tk !== "") {
      const lastFy = await getPreviousMonthAndFY(
        selectedYear,
        selectedMonth,
        formfinancialYear
      );

      if (lastFy) {
        setLoading(true);
        const payload = {
          action: "copyformdata",
          to: clientInfo?.tk,
          ty: "formgstr1",
          ffi: lastFy.financialYearId,
          fmo1: lastFy.month,
          fi: selectedFYearId,
          mo1: selectedMonth,
        };
        try {
          const response = await apiPost(
            process.env.REACT_APP_API_URL,
            payload
          );

          if (Number(response?.errordetails?.errorcode) > 0) {
            showError(response?.errordetails?.error);
            setCopyDataLoading(false);
          } else if (response?.responsedetails.success === "yes") {
            console.log("response", response?.responsedetails);
            if (response?.responsedetails?.success === "yes") {
              if (response?.responsedetails?.c1 === 0) {
                setTimeout(() => {
                  setCopyDataLoading(false);
                  showSuccess("No last month data found.");
                }, 3000);
              } else {
                setTimeout(() => {
                  setCopyDataLoading(false);
                  showSuccess("Data copied successfully to selected month");
                  getGSTR1Info();
                }, 3000);
              }
            }
          }
        } catch (err) {
          console.error("Error:", err);
          showError("Something went wrong");
          setCopyDataLoading(false);
        }
      }
    }
  };

  const submitToCA = async () => {
    if (formGSTR1Info.length <= 0) {
      showError("There is no such information to proceed");
      return;
    }

    if (selectedFYearId <= 0) {
      showError("Please select financial year to proceed");
      return;
    }

    if (selectedQuarter === "") {
      showError("Please select quarter to proceed");
      return;
    }

    if (selectedMonth === "") {
      showError("Please select month to proceed");
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will freeze the information. Please verify information before proceeding",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, submit it!",
      width: "320px",
      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "btn btn-sm btn-danger",
        cancelButton: "btn btn-sm btn-secondary",
      },
    });

    if (result.isConfirmed) {
      if (submitToCALoading) return;

      setsubmitToCALoading(true);

      const payload = {
        action: "formsubmit",
        to: clientInfo?.tk,
        ty: "formgstr1",
        fi: selectedFYearId,
        mn: selectedMonth,
        ae: "no",
      };

      if (clientInfo?.tk && clientInfo?.tk !== "") {
        try {
          const response = await apiPost(
            process.env.REACT_APP_API_URL,
            payload
          );

          if (Number(response?.errordetails?.errorcode) > 0) {
            showError(response?.errordetails?.error);
            setsubmitToCALoading(false);
          } else if (response?.responsedetails) {
            console.log("response", response?.responsedetails);
            if (response?.responsedetails?.success === "yes") {
              setTimeout(() => {
                setsubmitToCALoading(false);
                showSuccess("Selected month info submit to CA successfully!!!");
                getGSTR1Info();
              }, 3000);
            }
          }
        } catch (err) {
          console.error("Error:", err);
          showError("Something went wrong");
          setsubmitToCALoading(false);
        }
      }
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > maxPage) return;
    setActivePage(pageNumber);
  };

  return (
    <Container fluid className="p-md-4 form24q-container">
      <div className="mt-3">
        <AdminScreenHeader
          title="📋 Form GSTR-1"
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          placeholder="Search Supplier..."
          showSearch={true}
        />

        {/* Dropdowns */}
        <DateFilters
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          selectedQuarter={selectedQuarter}
          setSelectedQuarter={setSelectedQuarter}
          selectedMonth={selectedMonth}
          setSelectedMonth={setSelectedMonth}
          getFormInfo={getGSTR1Info}
          setSelectedFYearId={setSelectedFYearId}
          setFormInfo={setFormGSTR1Info}
          setFormFinancialYear={setFormFinancialYear}
        />

        {formGSTR1Info.length > 0 &&
          (isDataReviewedByCA ? (
            <div className="data-send-to-ca">
              This information has already been reviewed by the CA.
            </div>
          ) : isDataSendToCA ? (
            <div className="data-send-to-ca">
              This information has been sent to the CA for review.
            </div>
          ) : null)}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginBottom: "5px",
            marginTop: "-10px",
            paddingRight: "15px",
          }}
        >
          {/* <ExportToExceljs
            data={filteredGSTR1Info}
            fileName={`FormGSTR1_${selectedYear}_${selectedMonth}`}
            formName="formgstr1"
            clientName={clientInfo.client?.cn}
            clientTan={clientInfo.client?.ta}
            financialYear={selectedYear}
            month={selectedMonth}
          /> */}
          <Button
            className="left-btn btn-primary-submit-to-ca"
            onClick={deleteInfo}
            disabled={empIds?.length <= 0}
            variant="success"
          >
            <FaTrash
              style={{
                marginRight: "0.5rem",
                marginTop: "-0.3rem",
                transform: "scale(1.2)",
                transformOrigin: "center",
                fontSize: "0.7rem",
              }}
            />
            Delete Selected
          </Button>
        </div>
        <div className="table-container">
          <FormGSTR1Table
            data={filteredGSTR1Info}
            onEdit={handleEdit}
            // onDelete={deleteInfo}
            activePage={activePage}
            limit={limit}
            setEmpIds={setEmpIds}
            selectedMonth={selectedMonth}
            isDataSendToCA={isDataSendToCA}
            empIds={empIds}
          />
        </div>
        <Row className="mt-3 mb-2">
          <Col
            xs={12}
            className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2"
          >
            {/* Records per page */}
            <div className="d-flex align-items-center">
              <label
                className="me-2 mb-0"
                style={{ color: "#0d6efd", fontSize: "13px" }}
              >
                Records per page:
              </label>
              <Form.Select
                value={limit}
                onChange={(e) => {
                  const value =
                    e.target.value === "All"
                      ? filteredGSTR1Info.length
                      : parseInt(e.target.value);
                  setLimit(value);
                  setActivePage(1); // Reset to first page on limit change
                }}
                style={{ width: "100px" }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100000">All</option>
              </Form.Select>
            </div>

            {/* Pagination */}
            <Pagination className="mb-0">
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={activePage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(activePage - 1)}
                disabled={activePage === 1}
              />
              <Pagination.Item>
                {`Page ${activePage} of ${maxPage}`}
              </Pagination.Item>
              <Pagination.Next
                onClick={() => handlePageChange(activePage + 1)}
                disabled={activePage >= maxPage}
              />
              <Pagination.Last
                onClick={() => handlePageChange(maxPage)}
                disabled={activePage >= maxPage}
              />
            </Pagination>
          </Col>
        </Row>
        <div className="d-flex flex-column flex-md-row justify-content-between mb-2 mt-3 gap-2">
          <div className="align-self-start"></div>
          <div className="d-flex flex-column flex-md-row gap-2">
            <Button
              className="btn-primary-submit-to-ca "
              onClick={() => {
                submitToCA();
              }}
              disabled={isDataSendToCA}
            >
              {submitToCALoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Submiting Data...
                </>
              ) : (
                <>
                  <BsSend
                    style={{
                      color: "#2c3e50",
                      fontSize: "1.3rem",
                      paddingRight: "5px",
                    }}
                  />
                  Submit to CA
                </>
              )}
            </Button>
            <Button
              onClick={() => {
                handleAdd();
              }}
              disabled={isDataSendToCA}
            >
              <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
              Add Info
            </Button>
            <Button
              onClick={() => {
                getLastMonthData();
              }}
              disabled={isDataSendToCA}
            >
              {copyDataloading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Copying Data...
                </>
              ) : (
                <>
                  <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
                  Copy Last Month Data
                </>
              )}
            </Button>

            <Button
              onClick={() => {
                navigate("/client-dashboard");
              }}
            >
              <BsX
                style={{ color: "red", fontSize: "1.5rem", fontWeight: 600 }}
              />
              Close
            </Button>
          </div>
        </div>

        {/* Modal */}
        <Modal show={showModal} onHide={closeModal} size="lg" scrollable>
          <Modal.Header closeButton>
            <Modal.Title className="text-primary ">GSTR-1 Info</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="g-3">
                {formGSTR1Fields.map((field, index) => (
                  <React.Fragment key={index}>
                    <Col md={4}>
                      <Form.Group controlId={`field${index}`}>
                        <Form.Label className="textbox-label">
                          {index === 0 || index === 1 ? (
                            <>
                              {field.label}
                              <span style={{ color: "red" }}>*</span>
                            </>
                          ) : (
                            field.label
                          )}
                        </Form.Label>

                        {/* Conditionally render a date picker if index is 6 or 15 */}
                        {index === 3 ? (
                          <Form.Control
                            type="date"
                            name={field.key}
                            value={
                              formData[field.key]
                                ? moment(formData[field.key]).format(
                                    "YYYY-MM-DD"
                                  )
                                : ""
                            }
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                [field.key]: e.target.value,
                              }))
                            }
                          />
                        ) : (
                          <Form.Control
                            type="text"
                            name={field.key}
                            value={formData[field.key]}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                [field.key]: e.target.value,
                              }))
                            }
                          />
                        )}
                      </Form.Group>
                    </Col>

                    {(index + 1) % 6 === 0 && (
                      <Col md={12}>
                        <hr />
                      </Col>
                    )}
                  </React.Fragment>
                ))}
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <div className="text-center text-md-end mb-2">
              <Button
                style={{ width: "200px" }}
                className="me-md-3"
                variant="primary"
                onClick={() => {
                  saveGSTR1Info(
                    editingIndex !== null ? "updateInfo" : "addInfo"
                  );
                }}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
                    {editingIndex !== null ? "Updating..." : "Adding..."}
                  </>
                ) : (
                  <>
                    <BsPlus style={{ color: "#2c3e50", fontSize: "1.5rem" }} />
                    {editingIndex !== null ? "Update" : "Add"}
                  </>
                )}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
      {showLoader ? <Loader show={showLoader} /> : null}
    </Container>
  );
};

export default FormGSTR1;
